import React from 'react';
import { Modal, Button } from '@aidkitorg/component-library';

interface StartReviewConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  reviewId?: string;
}

export function StartReviewConflictModal({ isOpen, onClose, onConfirm, reviewId }: StartReviewConflictModalProps) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Overwrite Existing Review?"
      size="lg"
    >
      <div className="mb-6">
        <p className="text-gray-700">
          Your editor is not based on the existing review. Starting this review will overwrite any changes in the existing review.
        </p>
        <p className="text-gray-700">
          If you instead want to open an editor based on the existing review, you can do so from the <a href={`/distro-review/${reviewId}`} target="_blank" rel="noopener noreferrer">pending review page</a>.
        </p>
      </div>
      <div className="flex justify-end space-x-3">
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
        >
          Start Review
        </Button>
      </div>
    </Modal>
  );
}
